module.exports = __webpack_public_path__ + "img/home-view-filter-logo.980e7797.png";